import api from '../services/api';
const base='/admin/pulse';
const body=p=>p.then(r=>r.data);
export const pulseApi={
 zones:params=>body(api.get(base+'/zones',{params})),
 shadowSetup:()=>body(api.get(base+'/operating/setup')),
 previewShadowSetup:payload=>body(api.post(base+'/operating/setup-preview',payload)),
 saveShadowSetup:payload=>body(api.post(base+'/operating/setup',payload)),
 grantOperatingSubject:(id,payload)=>body(api.post(base+'/operating/subjects/'+encodeURIComponent(id),payload)),
 operating:()=>body(api.get(base+'/operating')),
 prepareOperating:payload=>body(api.post(base+'/operating/preparation-preview',payload)),
 saveOperating:payload=>body(api.post(base+'/operating',payload)),
 reconcileOperating:()=>body(api.post(base+'/operating/reconcile')),
 prepareOperatingDataset:payload=>body(api.post(base+'/operating/datasets',payload)),
 essenStart:()=>body(api.get(base+'/essen/start-campaign')),
 previewEssenStart:payload=>body(api.post(base+'/essen/start-campaign/preview',payload)),
 saveEssenStart:payload=>body(api.post(base+'/essen/start-campaign',payload)),
 essenStartCustomer:id=>body(api.get(base+'/essen/start-campaign/customers/'+encodeURIComponent(id))),
 saveEssenStartCustomer:(id,payload)=>body(api.post(base+'/essen/start-campaign/customers/'+encodeURIComponent(id),payload)),
 profiles:()=>body(api.get(base+'/profiles')),
 catalogComparison:()=>body(api.get(base+'/operating/catalog-comparison')),
 stopCatalogComparison:payload=>body(api.post(base+'/operating/catalog-comparison/stop',payload)),
 publication:()=>body(api.get(base+'/publication')),
 ownerOverview:()=>body(api.get(base+'/owner/overview')),
 ownerPriceComparison:()=>body(api.get(base+'/owner/price-comparison')),
 setAnonymousLearning:payload=>body(api.post(base+'/anonymous-learning',payload)),
 preparePublication:payload=>body(api.post(base+'/publication/prepare',payload)),
 applyPublication:id=>body(api.post(base+'/publication/proposals/'+encodeURIComponent(id)+'/apply')),
 recoverPublication:payload=>body(api.post(base+'/publication/bestand',payload)),
 publishProfiles:payload=>body(api.post(base+'/profiles',payload)),
 essenContract:()=>body(api.get(base+'/essen/contract')),
 essenSimulate:(revisionId,input)=>body(api.post(base+'/essen/simulate',{revisionId,input})),
 learning:()=>body(api.get(base+'/learning')),
 validateLearning:payload=>body(api.post(base+'/learning/validate',payload)),
 startLearning:payload=>body(api.post(base+'/learning/jobs',payload)),
 cancelLearning:id=>body(api.post(base+'/learning/jobs/'+encodeURIComponent(id)+'/cancel')),
 bookingComparison:payload=>body(api.post(base+'/comparison/booking',payload)),
 distanceEvidence:payload=>body(api.post(base+'/comparison/distance',payload)),
 comparison:cursor=>body(api.get(base+'/comparison',{params:cursor?{cursor}:{}})),
 retryComparison:()=>body(api.post(base+'/comparison/retry',{})),
 publicationReadiness:()=>body(api.get(base+'/publication-readiness')),
 publish:payload=>body(api.post(base+'/mode',payload)),
 audit:()=>body(api.get(base+'/audit')),
 prepareModel:datasetId=>body(api.post(base+'/models/prepare',{datasetId})),
 registerModel:payload=>body(api.post(base+'/models/register',payload)),
 diagnostics:revisionId=>body(api.get(base+'/diagnostics',{params:revisionId?{revisionId}:{}})),
 runtimeSimulate:payload=>body(api.post(base+'/runtime/simulate',payload)),
 lifecycleSimulate:payload=>body(api.post(base+'/lifecycle/simulate',payload)),
 models:()=>body(api.get(base+'/models')),
 status:()=>body(api.get(base+'/status')),
 revisions:()=>body(api.get(base+'/config/revisions')),
 revision:id=>body(api.get(base+'/config/'+id)),
 save:payload=>body(api.post(base+'/config/revisions',payload)),
 validate:(revisionId,scope)=>body(api.post(base+'/validate',{revisionId,scope})),
 simulate:(revisionId,input)=>body(api.post(base+'/simulate',{revisionId,input})),
 preview:payload=>body(api.post(base+'/import-preview',payload)),
 previewCurrent:revisionId=>body(api.post(base+'/import-current-preview',{revisionId})),
 signalLab:payload=>body(api.post(base+'/signal-lab',payload)),
 curveLab:payload=>body(api.post(base+'/curve-lab',payload)),
 dataLab:scenario=>body(api.post(base+'/data-lab',{scenario})),
 dataPolicy:()=>body(api.get(base+'/data-policy')),
 dataPolicyRevision:id=>body(api.get(base+'/data-policy/'+id)),
 saveDataPolicy:payload=>body(api.post(base+'/data-policy',payload)),
};
